'use strict'

const uploadBox = {
  data () {
    return {
      error: {
        maxLines: false,
        invalidFileType: false,
        emptyFile: false,
        oldTemplate: false
      }
    }
  },
  methods: {
    handleChangeUploadBox ({ maxLines = false, invalidFileType = false, emptyFile = false, oldTemplate = false }) {
      this.error = {
        ...this.error,
        maxLines,
        invalidFileType,
        emptyFile,
        oldTemplate
      }

      console.table({ ...this.error })
    },

    handleSuccessUploadBox (payload) {
      const { insert: success, updates, total } = payload
      this.closeDialogLinesWithErrors && this.closeDialogLinesWithErrors()

      if ((success === total) || updates === total || (success + updates === total)) {
        this.updateStep({ currentStep: 2, type: 'success', payload })
        return
      }

      this.updateStep({ currentStep: 2, type: 'warning', payload })
    },

    handleErrorUploadBox (error) {
      error && this.updateStep({ currentStep: 1, type: 'error' })
      error === 'maxLinesError' && this.handleChangeUploadBox({ maxLines: true })
      error === 'invalidFileType' && this.handleChangeUploadBox({ invalidFileType: true })
      error === 'emptyFile' && this.handleChangeUploadBox({ emptyFile: true })
      error === 'oldTemplate' && this.handleChangeUploadBox({ oldTemplate: true })
    },

    updateStep (payload) {
      this.$emit('updateStep', payload)
    }
  }
}

export default uploadBox
